import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { SessionStateService } from '../../core/session-state.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private authService: AuthService,
    private sessionState: SessionStateService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (isPlatformBrowser(this.platformId)) {
      const token = this.sessionState.token();

      if (token && !this.authService.isTokenExpired(token)) {
        return true;
      }
      // If token is expired, try to refresh
      if (this.sessionState.refreshToken()) {
        return this.authService.refreshToken().pipe(
          map((response: any) => {
            // If refresh is successful, allow access
            if (response && response.token) {
              return true;
            }
            // If no token in response, redirect to login
            return this.router.parseUrl('/login');
          }),
          catchError(() => {
            // If refresh fails (e.g., 400), redirect to login
            return of(this.router.parseUrl('/login'));
          }),
        );
      }
    }
    // Redirect to login if not authenticated or token expired and no refresh token
    return this.router.parseUrl('/login');
  }
}
